import { IWorkflowsPageProps, WorkflowsPage } from '@enter/core';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { useParams } from 'react-router-dom';
import { DataTableCard, PageLayout, PageLayoutRow } from 'components';
import { IObservedRootStore } from 'stores';

const LAYOUT: IWorkflowsPageProps['layout'] = { Page: PageLayout, Row: PageLayoutRow, Card: DataTableCard };

/** Workflows on the provider console (FE-167): core's `WorkflowsPage`, which Support mounts too. */
export const Workflows: React.FC<IObservedRootStore> = inject('rootStore')(
    observer(({ rootStore }: IObservedRootStore) => {
        const { accountId } = useParams();
        const claimHref = React.useCallback(
            (claimId: string): string => (accountId ? `/${accountId}/claims/${claimId}` : `/claims/${claimId}`),
            [accountId],
        );

        if (!rootStore) {
            return <></>;
        }

        return <WorkflowsPage store={rootStore.workerReportStore} layout={LAYOUT} claimHref={claimHref} />;
    }),
);
